// Port of api/fuel/app/classes/insights/collection/status.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Enum from 'offline/enum'

export default Segment.extend({
    name: 'status',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var status = {}

        var rawStatus = Util.queryFast('\
            SELECT \
                SUM(collection_own) AS own, \
                SUM(collection_prevowned) AS prevowned, \
                SUM(collection_fortrade) AS fortrade, \
                SUM(collection_want) AS want, \
                SUM(collection_wanttoplay) AS wanttoplay, \
                SUM(collection_wanttobuy) AS wanttobuy, \
                SUM(collection_wishlist) AS wishlist, \
                SUM(collection_preordered) AS preordered, \
                SUM(collection_hasparts) AS hasparts, \
                SUM(collection_wantparts) AS wantparts \
            FROM \
                collection c \
            WHERE \
                user_id IN(' + Util.in(userIndex) + ') \
        ')

        var keys = Object.keys(Enum.collection_status_constant)

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i]

            status[key] = {
                count: parseInt(rawStatus[0][key], 10) || 0,
                id: key
            }
        }

        return {
            status: status
        }

    }
})
